import type { SiteRoute } from './router';

export type ContactEvent = 'cta' | 'form_view' | 'form_start' | 'error';
export type ContactPage = 'home' | 'article' | 'guides' | 'about' | 'tools' | 'tool' | 'other';

const trackedPages = new Set<SiteRoute['kind']>(['home', 'article', 'guides', 'about', 'tools', 'tool']);

export const contactPageForRoute = (route: SiteRoute): ContactPage =>
  trackedPages.has(route.kind) ? (route.kind as ContactPage) : 'other';

// Compteurs agrégés par jour, sans cookie ni identifiant : aucune donnée saisie n’est transmise.
export const trackContactEvent = (event: ContactEvent, page: ContactPage) => {
  if (typeof window === 'undefined') return;
  void fetch('/api/contact-events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event, page }),
    keepalive: true,
  }).catch(() => {
    // La mesure ne doit jamais bloquer la prise de contact.
  });
};

export const isContactLink = (target: EventTarget | null) => {
  const link = target instanceof Element ? target.closest('a[href]') : null;
  const href = link?.getAttribute('href') || '';
  return href === '#contact' || href === '/#contact';
};
